import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { FontWeight, Colors } from '../../../../assets/styles';

import { styled } from '@mui/material/styles';
import TableCell from '@mui/material/TableCell';

const useStyles = makeStyles((theme: Theme) => {
  const pxToRem = (px: number): string => `${px / 16}rem`;
  return {
    container: {
    position: 'relative',
    width: '100%',
  },
  tableContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 34px',
    border: `1px solid ${Colors.Gray1}`,
    borderRadius: 2,
    backgroundColor: Colors.White,
    boxShadow: '0 2px 2px 0 rgba(0,0,0,0.05)',
    marginBottom: 15,
  },
  text: {
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: '60px',
  },
  textLink: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  table: {
    width: '100%',
    backgroundColor: Colors.White,
    border: `1px solid ${Colors.Gray1}`,
     marginBottom: '24px !important',
  },
  searchForm: {
    marginBottom: 20,
  },
  searchInput: {
    maxWidth: 340,
  },
  moreBtn: {
    fontSize: 14,
    fontWeight: FontWeight.Bold,
    color: Colors.Blue1,
    marginBottom: 30,
  },
  noResults: {
    textAlign: 'center',
    fontSize: pxToRem(22),
    paddingTop: pxToRem(130),
  },
  reportWrapper: {
    height: 0,
    overflow: 'hidden',
  },
}
});

export default useStyles;


export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  paddingLeft: 24,
  fontSize: 15,
  color: Colors.Gray,

  '&.MuiTableCell-head': {
    fontWeight: FontWeight.Bold,
    color: Colors.Gray,
    paddingTop: 8,
    paddingBottom: 8,
  },

  '&.MuiTableCell-body': {
    fontSize: 15,
  },
}));
